/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_R2_EndpointInputs */

const en_admin_settings_fields_r2_endpoint = /** @type {(inputs: Admin_Settings_Fields_R2_EndpointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoint`)
};

const zh_admin_settings_fields_r2_endpoint = /** @type {(inputs: Admin_Settings_Fields_R2_EndpointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`端点`)
};

/**
* | output |
* | --- |
* | "Endpoint" |
*
* @param {Admin_Settings_Fields_R2_EndpointInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_r2_endpoint = /** @type {((inputs?: Admin_Settings_Fields_R2_EndpointInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_R2_EndpointInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_r2_endpoint(inputs)
	return zh_admin_settings_fields_r2_endpoint(inputs)
});
export { admin_settings_fields_r2_endpoint as "admin.settings.fields.r2_endpoint" }